export class PatientHistoryFilterModel {
    OrderDate: string;
    Hn: string;
    RegId?: number;
    OrgId?: number;
    IsHistory?: boolean;
}